import { Capacitor } from '@capacitor/core';

/**
 * Platform detection utilities for Capacitor native apps
 * Use these to conditionally execute native-only code
 */

/**
 * Returns true if running in a native iOS/Android container
 */
export const isNative = (): boolean => Capacitor.isNativePlatform();

/**
 * Returns true if running on iOS (native or web Safari)
 * For native-only iOS checks, combine with isNative()
 */
export const isIOS = (): boolean => Capacitor.getPlatform() === 'ios';

/**
 * Returns true if running on Android (native or web Chrome)
 * For native-only Android checks, combine with isNative()
 */
export const isAndroid = (): boolean => Capacitor.getPlatform() === 'android';

/**
 * Returns true if running in a web browser (not native)
 */
export const isWeb = (): boolean => Capacitor.getPlatform() === 'web';

/**
 * Get the current platform as a string
 * Returns: 'ios' | 'android' | 'web'
 */
export const getPlatform = (): string => Capacitor.getPlatform();
